
var versi = "8.2.0";
var urlx = "192.168.0.103"; //"192.168.100.128";
export const test = false;
export const versiCode = 750;

// DEV
/*
export const api = versi;
export const url = "http://"+urlx+"/tagihan/"+versi+"/pelanggan/api";
export const urlOwner = "http://"+urlx+"/tagihan/"+versi;
export const assets = "http://"+urlx+"/tagihan/";
export const assetsLain = "http://"+urlx+"/tagihan_user_assets/images/";
export const urlACS = "http://"+urlx+"/genie";
export const qrUrl = "https://beatcom.web.id/qr/";

*/

// BUILD
// BEATCOM
/*
export const api = versi;

//export const url = "https://blonjo.web.id/beat/API/WIFI/v."+versi+"/pelanggan/api";

export const url = "https://akulelah.web.id/_api/owner/v."+versi+"/pelanggan/api";

export const urlOwner = "https://blonjo.web.id/beat/API/WIFI/v."+versi;
export const assets = "https://blonjo.web.id/beat/API/WIFI/";
export const assetsLain = "https://beatcom.web.id/tagihan_user_assets/images/";
export const urlACS = "https://beatcom.web.id/genie";
export const qrUrl = "https://beatcom.web.id/qr/";
*/

// BUILD
// APLIKABEAT
export const api = versi;
export const url = "https://malesdev.com/_api/owner/v."+versi+"/pelanggan/api";
export const urlOwner = "https://malesdev.com/beat/API/WIFI/v."+versi;
export const assets = "https://malesdev.com/_api/owner/assets/"; // logo owner
export const assetsLain = "https://malesdev.com/tagihan_user_assets/images/";
export const urlACS = "https://beatcom.web.id/genie";
export const qrUrl = "https://malesdev.com/qr/";


// WEBPACK FOOTER //
// ./src/var.js